import { Injectable } from '@angular/core'
import { ProductListComponentService, ViewConfig } from '@spartacus/storefront'
import {
  ActivatedRouterStateSnapshot,
  CurrencyService,
  LanguageService,
  ProductSearchService, RouterState,
  RoutingService
} from '@spartacus/core'
import { ActivatedRoute, Router } from '@angular/router'
import { combineLatest, Observable } from 'rxjs'
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MbProductListComponentService extends ProductListComponentService {

  constructor (protected productSearchService: ProductSearchService,
               protected routing: RoutingService,
               protected activatedRoute: ActivatedRoute,
               protected currencyService: CurrencyService,
               protected languageService: LanguageService,
               protected router: Router,
               protected config: ViewConfig) {
    super(productSearchService, routing, activatedRoute, currencyService, languageService, router, config)
  }

  /**
   * Observes the route and performs a search on each route change.
   *
   * Context changes, such as language and currencies are also taken
   * into account, so that the search is performed again.
   */
  protected searchByRouting$: Observable<ActivatedRouterStateSnapshot> =
    combineLatest([
      this.routing.getRouterState().pipe(
        distinctUntilChanged((x, y) =>
          // router emits new value also when the anticipated `nextState` changes
          // but we want to perform search only when current url changes
           x.state.url === y.state.url
        )
      ),
      ...this.mbSiteContext,
    ]).pipe(
      debounceTime(0),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      map(([routerState, ..._context]) => (routerState as RouterState).state),
      tap((state: ActivatedRouterStateSnapshot) => {
        const criteria = this.getCriteriaFromRoute(
          state.params,
          state.queryParams
        )
        this.search(criteria)
      })
    )

  /**
   * The site context is used to update the search query in case of a
   * changing context. The context will typically influence the search data.
   *
   * We keep this private for now, as we're likely refactoring this in the next
   * major version.
   */
  private get mbSiteContext (): Observable<string>[] {
    // TODO: we should refactor this so that custom context will be taken
    // into account automatically. Ideally, we drop the specific context
    // from the constructor, and query a ContextService for all contexts.

    return [this.languageService.getActive(), this.currencyService.getActive()]
  }
}
